module.exports = __webpack_public_path__ + "img/xaplogo.3bfd5637.png";